/**
 * Load optional components by CSS selector only when their markup exists. Watch added
 * subtrees too: Quick Add, recommendations, filters and the theme editor can
 * insert components without executing the script tags in the fetched HTML.
 * Core navigation, product forms and cart modules keep their normal loading path.
 */
const manifest = document.getElementById('100-horizon-optional-components');

if (manifest) {
  /** @type {Record<string, string>} */
  const modules = JSON.parse(manifest.textContent || '{}');
  const remaining = new Map(Object.entries(modules));
  const requested = new Set();
  let selector = [...remaining.keys()].join(',');

  /** @param {Element} element */
  function loadComponent(element) {
    for (const [componentSelector, url] of remaining) {
      if (requested.has(componentSelector) || !element.matches(componentSelector)) continue;

      requested.add(componentSelector);
      import(url).then(() => {
        remaining.delete(componentSelector);
        selector = [...remaining.keys()].join(',');
        if (!selector) observer.disconnect();
      }).catch((error) => {
        // Keep failures visible without retrying on every unrelated DOM mutation.
        console.error(`[optional-components] Could not load ${componentSelector}`, error);
      });
    }
  }

  /** @param {Document | Element} root */
  function scan(root) {
    if (!selector) return;
    if (root instanceof Element) loadComponent(root);
    for (const element of root.querySelectorAll(selector)) loadComponent(element);
  }

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element && node.isConnected) scan(node);
      }
    }
  });

  function observe() {
    if (!selector) return;
    observer.observe(document.body, { childList: true, subtree: true });
    scan(document);
  }

  // Module execution follows parsing. Start immediately, without waiting for
  // window.load, an idle timer, a scroll or the shopper's first interaction.
  observe();
  window.addEventListener('pagehide', () => observer.disconnect());
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) observe();
  });
}
